import COLORS from 'theme/colors';
import { customStyled, Box } from '@mafc/trolly';

export const Message = customStyled(Box)(props => {
  let colorProps = {};
  if (props.withColor) {
    colorProps = { color: COLORS.BLACK };
  }
  return {
    lineHeight: '16px',
    fontSize: '12px',
    marginBottom: '8px',
    ...colorProps,
  };
});

export const MinimumOrderNotification = customStyled(Box)(({ theme }) => ({
  marginBottom: theme.space[3],
}));

export const ProgressBar = customStyled(Box)(({ theme }) => ({
  background: theme.colors.GRAY_100,
}));

export const FilledProgressBar = customStyled(Box)<{ width: number }>(({ theme, width }) => ({
  background: theme.colors.yellow,
  height: '2px',
  width: `${width}%`,
}));
